import {
  Box,
  Button,
  Card,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React, { useContext } from 'react';
import { poppins300 } from 'theme/common.style';
import { useHistory } from 'react-router-dom';
import { datacontext } from 'modules/AppLayout/AppLayout';

const WarningIcon = (matchessm) => {
  return (
    <svg
      width={matchessm ? '36' : '66'}
      height={matchessm ? '36' : '66'}
      viewBox="0 0 66 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33 11C27.1652 11 21.5695 13.3179 17.4437 17.4437C13.3179 21.5695 11 27.1652 11 33C11 38.8348 13.3179 44.4305 17.4437 48.5564C21.5695 52.6822 27.1652 55 33 55C38.8348 55 44.4305 52.6822 48.5564 48.5564C52.6822 44.4305 55 38.8348 55 33C55 27.1652 52.6822 21.5695 48.5564 17.4437C44.4305 13.3179 38.8348 11 33 11ZM5.5 33C5.5 17.8118 17.8118 5.5 33 5.5C48.1882 5.5 60.5 17.8118 60.5 33C60.5 48.1882 48.1882 60.5 33 60.5C17.8118 60.5 5.5 48.1882 5.5 33Z"
        fill="white"
      />
      <path
        d="M33 38.5C32.2707 38.5 31.5712 38.2103 31.0555 37.6945C30.5397 37.1788 30.25 36.4793 30.25 35.75V19.25C30.25 18.5207 30.5397 17.8212 31.0555 17.3055C31.5712 16.7897 32.2707 16.5 33 16.5C33.7293 16.5 34.4288 16.7897 34.9445 17.3055C35.4603 17.8212 35.75 18.5207 35.75 19.25V35.75C35.75 36.4793 35.4603 37.1788 34.9445 37.6945C34.4288 38.2103 33.7293 38.5 33 38.5ZM28.875 45.375C28.875 44.281 29.3096 43.2318 30.0832 42.4582C30.8568 41.6846 31.906 41.25 33 41.25C34.094 41.25 35.1432 41.6846 35.9168 42.4582C36.6904 43.2318 37.125 44.281 37.125 45.375C37.125 46.469 36.6904 47.5182 35.9168 48.2918C35.1432 49.0654 34.094 49.5 33 49.5C31.906 49.5 30.8568 49.0654 30.0832 48.2918C29.3096 47.5182 28.875 46.469 28.875 45.375Z"
        fill="white"
      />
    </svg>
  );
};

const DepositPaymentOverDueBannerBuyer = (props) => {
  const { isBuyerDashboard, buyerDashboardDetails, getBuyerIndividualValue } =
    props;

  const history = useHistory();
  const theme = useTheme();
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matcheslg = useMediaQuery(theme.breakpoints.down('lg'));
  const matches450 = useMediaQuery(theme.breakpoints.down(450));
  const matchesmac = useMediaQuery(theme.breakpoints.down(1280));

  const flagDepositPaymentStatus = isBuyerDashboard
    ? buyerDashboardDetails?.flagDepositPaymentStatus
    : getBuyerIndividualValue?.PropertyDetails?.flagDepositPaymentStatus;

  const buttonText =
    flagDepositPaymentStatus === 'Processing'
      ? 'Processing'
      : 'Process Payment';

  const PropertyId = isBuyerDashboard
    ? buyerDashboardDetails?.property?.propertyId
    : getBuyerIndividualValue?.PropertyDetails?.property?.propertyId;

  const { setShowMessage, setMessagedata } = useContext(datacontext);

  const OpenBinderChat = (currentBinder) => {
    if (currentBinder) {
      setShowMessage(true);
      setMessagedata({ binderId: currentBinder });
    }
  };

  return (
    <>
      <Card
        variant="outlined"
        sx={{
          background: '#E03942FA',
          width: '100%',
          borderRadius: '20px',
          p: matchessm ? 1.5 : 2,
          display: 'flex',
          flexDirection: 'row',
          height: matchessm ? 390 : matchesmd ? 330 : 300,
        }}
      >
        <Grid
          xs={12}
          container
          sx={{
            display: 'flex',
            alignItems: 'start',
            padding: matchessm ? 0.5 : 3,
          }}
        >
          <Grid
            item
            xs={12}
            sx={{ textAlign: 'left', pl: 0 }}
            padding={!matchessm && '0px 0 0 20px'}
          >
            <Typography
              sx={{
                color: '#FFF',
                fontWeight: 300,
                fontSize: matchessm ? '11px' : '16px',
                fontFamily: 'poppins',
                textDecoration: 'none',
              }}
            >
              {buyerDashboardDetails?.propertyAddress?.streetName ||
                getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                  ?.streetName}
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction={'row'}
            marginLeft={!matchessm && '-20px'}
          >
            <Grid
              item
              xs={12}
              md={1}
              xl={0.5}
              sx={{
                display: matchesmd ? 'none' : 'flex',
                justifyContent: 'center',
                alignItems: 'baseline',
              }}
            >
              <WarningIcon />
            </Grid>
            <Grid item sm={12} md={12} lg={7.2} xl={7.7}>
              <Box
                sx={{
                  fontSize: !matches450 ? '30px' : '16px',
                  fontWeight: 600,
                  color: '#FFF',
                  fontFamily: 'poppins',
                  paddingBottom: matchessm ? 0 : matcheslg ? 2 : 3,
                  display: 'flex',
                  alignItems: 'center',
                  gap: matchessm && 1.5,
                }}
              >
                {matchesmd && (
                  <Box>
                    <WarningIcon matchessm={matchessm} />
                  </Box>
                )}
                Deposit Payment - OVERDUE!
              </Box>

              <Typography
                sx={{
                  fontSize: matchessm ? '11px' : '16px',
                  fontFamily: 'poppins',
                  fontWeight: 300,
                  color: '#FFF',
                  paddingBottom: matchessm ? 0 : 4,
                }}
              >
                You have an OVERDUE deposit payment for{' '}
                <Typography
                  component="span"
                  sx={{
                    color: '#FFF',
                    fontWeight: matchessm ? 400 : 700,
                    fontSize: matchessm ? '11px' : '16px',
                    fontFamily: 'poppins',
                    textTransform: 'capitalize',
                  }}
                >
                  {getBuyerIndividualValue?.PropertyDetails?.propertyAddress
                    ?.streetName ||
                    buyerDashboardDetails?.propertyAddress?.streetName}
                </Typography>
                . Please process this payment immediately as you are now in
                default of your deposit payment obligations.
              </Typography>
              <Box
                sx={{
                  fontSize: matchessm ? '11px' : '16px',
                  fontFamily: 'poppins',
                  fontWeight: 300,
                  mt: matchessm ? 1 : 1.5,
                  color: '#FFF',
                  lineHeight: 'normal',
                }}
              >
                Should you fail to process your deposit payment today, your
                account will restricted and you remain at risk of being
                permanently barred. Please process your deposit payment
                immediately to avoid further action.
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={3.8}
              sx={{
                display: 'flex',
                alignItems: 'end',
                flexWrap: 'wrap',
                justifyContent: matchessm ? 'space-between' : 'end',
                mt: matchessm && '10px',
              }}
              gap={matchessm ? 0.5 : 2}
            >
              <Button
                varient="outlined"
                onClick={() => {
                  if (isBuyerDashboard) {
                    OpenBinderChat(buyerDashboardDetails?.agentBuyerBinderId);
                  } else {
                    OpenBinderChat(
                      getBuyerIndividualValue?.PropertyDetails
                        ?.agentBuyerBinderId
                    );
                  }
                }}
                sx={{
                  height: matchessm ? 35 : 42,
                  width: matchessm ? 'auto' : '132px',
                  borderRadius: '5px',
                  fontSize: matchessm ? '12px' : '14px',
                  textTransform: 'none',
                  border: '1px solid #E6F2FF',
                  backgroundColor: 'transparent',
                  color: '#E6F2FF',
                  fontFamily: 'poppins',
                  fontWeight: 300,
                }}
              >
                Contact Agent
              </Button>

              <Button
                onClick={() => {
                  if (isBuyerDashboard) {
                    history.push({
                      pathname: `market/${PropertyId}`,
                      state: {
                        propertyIds: true,
                        isDepositPaymentBanner: true,
                      },
                    });
                  } else {
                    history.push({
                      pathname: history.location.pathname,
                      state: {
                        propertyIds: true,
                        isDepositPaymentBanner: true,
                      },
                    });
                  }
                }}
                sx={{
                  height: matchessm ? 35 : 42,
                  width: matchessm ? 'auto' : '155px',
                  borderRadius: '5px',
                  fontSize: matchessm ? '12px' : '14px',
                  textTransform: 'none',
                  border: '1px solid #E6F2FF',
                  backgroundColor: '#FFF',
                  color: '#262626',
                  fontWeight: 400,
                  fontFamily: 'poppins',
                  '&:hover': {
                    bgcolor: '#FFFFFF',
                    color: '#262626',
                  },
                }}
              >
                {buttonText}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Card>
    </>
  );
};

export default DepositPaymentOverDueBannerBuyer;
